import type {ToastProps} from '@spaced-out/ui-design-system/lib/components/Toast/Toast';
import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useDispatch} from 'react-redux';
import {useAsyncDependency} from 'src/hooks/useAsyncDependency';
import usePrivilege from 'src/hooks/usePrivilege';
import {getReferralSettings} from 'src/action-creators/referral-v2/referral-settings';
import {
  ButtonTab,
  ButtonTabs,
} from '@spaced-out/ui-design-system/lib/components/ButtonTabs';
import {
  Toast,
  ToastBody,
  ToastTitle,
} from '@spaced-out/ui-design-system/lib/components';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {displayTime} from 'src/utils/date-time-2';
import Notifications from 'src/components/referral-v2/settings/notifications';
import OneTimeSettings from 'src/components/referral-v2/settings/one-time-settings';
import OtherSettings from 'src/components/referral-v2/settings/other-settings';
import Profile from 'src/components/referrer-portal/settings/profile/profile';
import css from 'src/components/referral-v2/settings/root.css';


const stepToComponent = {
  profile: Profile,
  notifications: Notifications,
  oneTime: OneTimeSettings,
  others: OtherSettings,
} as const;

const ReferralSettingsPage = () => {
  const dispatch = useDispatch();
  const {t} = useLabelTranslation();

  const [selectedTab, setSelectedTab] = React.useState('profile');

  const hasSuperAdminAccess = usePrivilege('ADMIN_REFERRALS_V2');

  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly profile: () => Element; readonly notifications: () => Element; readonly oneTime: () => Element; readonly others: () => Element; }'.
  const Component = stepToComponent[selectedTab];

  const isLoading = useAsyncDependency(
    () => dispatch(getReferralSettings()),
    [],
  );

  return (
    <div className={css.settingsContainer}>
      <ButtonTabs
        onButtonTabSelect={(e) => setSelectedTab(e)}
        selectedButtonTabId={selectedTab}
      >
        <ButtonTab id="profile">{t('Profile', 'Profile')}</ButtonTab>
        <ButtonTab id="notifications">
          {t('Notifications', 'Notifications')}
        </ButtonTab>
        {hasSuperAdminAccess && (
          <ButtonTab id="oneTime">{t('Onetime', 'One-time')}</ButtonTab>
        )}
        <ButtonTab id="others">{t('Others', 'Others')}</ButtonTab>
      </ButtonTabs>
      {isLoading ? (
        <CircularLoader size="large" className={css.loader} />
      ) : (
        <Component />
      )}
    </div>
  );
};
export default ReferralSettingsPage;

export const thresholdUpdateMessage = (): React.ReactElement<
  React.ComponentProps<(props: ToastProps) => React.ReactNode>
> => {
  const currentDate = new Date();
  const {t, language} = useLabelTranslation();
  return (
    <Toast
      initialFocus={0}
      semantic="success"
      time={`${t('Today', 'Today')}: ${displayTime(currentDate, language)}`}
    >
      {/* (TODO(san): Remove this disabling once figured out how to fix this) */}
      <ToastTitle semantic="primary">
        {t('Balance_threshold_updated', 'Balance threshold updated')}
      </ToastTitle>
      <ToastBody>
        {t(
          'Your_minimum_balance_threshold_successfully_updated',
          'Your minimum balance threshold successfully updated',
        )}
      </ToastBody>
    </Toast>
  );
};
